<template>
    <div v-if="loggedIn" class="container mx-auto px-2 py-4">
        <h2> E-Mail Verifizieren</h2>

        Vielen Dank für Ihre Registrierung. Zur Bestätigung Ihrer Daten haben wir Ihnen eine E-Mail an Ihre Adresse geschickt. Bitte bestätigen Sie Ihre E-Mail Adresse.<br><br>

        Sollten Sie keine E-Mail erhalten haben, prüfen Sie bitte Ihren Spam Ordner.<br/><br/>

        <base-button @click="onResend" :loading="axiosCall">
            Bestätigungs-E-Mail nochmal senden
        </base-button>
    </div>
</template>

<script>
import {useStore} from "vuex";
import {useRouter} from 'vue-router'
import {computed, getCurrentInstance, ref, watch} from 'vue';
import {API} from "@/utils/api";

export default {

    setup () {
        const store = useStore();
        const loggedIn = computed(() => store.getters['Customer/isLoggedIn'])
        const verified = computed(() => store.getters['Customer/verified'])
        const userData = computed(() => store.getters['Customer/userData'])
        const axiosCall = ref(false);
        const router = useRouter();
        const internalInstance = getCurrentInstance();
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;

        if(verified.value == 'yes'){
            router.push('/form');
            return;
        }

        watch(verified, (selection, prevSelection) => {
            if(verified.value == 'yes'){

                emitter.emit("flash-message", {
                    text: 'Ihre E-Mail wurde bestätigt!',
                    type: 'success'
                });

                router.push('/form');
            }
        })

        const onResend = () => {

            axiosCall.value = true

            API.post('email/resend').then((resp) => {
                axiosCall.value = false
                emitter.emit("flash-message", {
                    text: resp.data.message,
                    type: 'success'
                });

            }).catch((error) => {
                axiosCall.value = false
                console.error(error)
            })
        }

        return {
            loggedIn,
            verified,
            onResend,
            axiosCall,
            userData
        }
    }
}
</script>
